import type { PlayerData, ApiResponse } from '@/types/index';

/**
 * Mock API pour le développement local
 */
export const mockApi = {
  getPlayer: async (uuid: string): Promise<ApiResponse<PlayerData>> => {
    // Simuler un délai réseau
    await new Promise(resolve => setTimeout(resolve, 500));

    return {
      success: true,
      data: {
        uuid: uuid,
        username: 'PlayerTest',
        email: 'player@test.com',
        currency: {
          coins: 15420,
          gems: 850,
          points: 3200,
        },
        lastSeen: new Date(Date.now() - 3600000).toISOString(), // Il y a 1h
        rank: 'VIP',
        banned: false,
        registeredAt: new Date(Date.now() - 86400000 * 30).toISOString(), // Il y a 30 jours
      },
    };
  },

  getPlayerByUsername: async (username: string): Promise<ApiResponse<PlayerData>> => {
    await new Promise(resolve => setTimeout(resolve, 500));

    return {
      success: true,
      data: {
        uuid: '550e8400-e29b-41d4-a716-446655440000',
        username: username,
        email: `${username.toLowerCase()}@test.com`,
        currency: {
          coins: 15420,
          gems: 850,
          points: 3200,
        },
        lastSeen: new Date(Date.now() - 3600000).toISOString(),
        rank: 'VIP',
        banned: false,
        registeredAt: new Date(Date.now() - 86400000 * 30).toISOString(),
      },
    };
  },
};
